import { appRouter } from '@app/app-router';
import { ShareLevelConfig } from '@app/drive/share-dialog/share-levels';
import { FetchShareableLinkPageResponse } from '@app/drive/shareable-link/queries/use-shareable-link-page';
import { BaseBackendUser } from '@common/auth/base-backend-user';
import { BaseBackendBootstrapData } from '@common/core/base-backend-bootstrap-data';
import { CommonProvider } from '@common/core/common-provider';
import { BaseBackendSettings } from '@common/core/settings/base-backend-settings';
import { ignoredSentryErrors } from '@common/errors/ignored-sentry-errors';
import * as Sentry from '@sentry/react';
import { getBootstrapData } from '@ui/bootstrap-data/bootstrap-data-store';
import { rootEl } from '@ui/root-el';
import { createRoot, RootOptions } from 'react-dom/client';
import './App.css';

declare module '@ui/settings/settings' {
  interface Settings extends BaseBackendSettings {
    drive?: {
      details_default_visibility: boolean;
      default_view: 'list' | 'grid';
      send_share_notification: boolean;
      default_available_space: number;
      direct_links: boolean;
      copy_link_default: 'shareable' | 'direct';
      share_levels?: ShareLevelConfig[];
    };
    share?: {
      suggest_emails: boolean;
    };
  }
}

declare module '@ui/bootstrap-data/bootstrap-data' {
  interface BootstrapData extends BaseBackendBootstrapData {
    loaders?: {
      shareableLinkPage?: FetchShareableLinkPageResponse;
    };
  }
}

declare module '@ui/types/user' {
  interface User extends BaseBackendUser {
    //
  }
}

const data = getBootstrapData();
let options: RootOptions | undefined = undefined;
const sentryDsn = data.settings.logging.sentry_public;
if (sentryDsn && import.meta.env.PROD) {
  Sentry.init({
    dsn: sentryDsn,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 0.2,
    ignoreErrors: ignoredSentryErrors,
    release: data.sentry_release,
  });

  options = {
    onUncaughtError: Sentry.reactErrorHandler((error, errorInfo) => {
      console.warn('Uncaught error', error, errorInfo.componentStack);
    }),
    onCaughtError: Sentry.reactErrorHandler(),
    onRecoverableError: Sentry.reactErrorHandler(),
  };
}

const app = <CommonProvider router={appRouter} />;

createRoot(rootEl, options).render(app);
